export const OPTHINES = {
  voteName: '2019poject/2019community',
  mustSearch: 'Button',
  buttonBg: '#d83334',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: 'rgb(27, 88, 169)',
    inactiveBgColor: '#fff',
  },
  tabs: [
    // {
    //   tabName: '人物点赞',
    //   tabPath: '/2019LJFL/givelike',
    // },
    {
      tabName: '首页',
      tabPath: '/2019LJFL/give-like',
    },
    {
      tabName: '点赞规则',
      tabPath: '/2019LJFL/likerules',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019LJFL/news',
    },

    {
      tabName: '活动介绍',
      tabPath: '/2019LJFL/rules',
    },
  ],
};
